import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import * as moment from "moment";
import * as _ from 'lodash';

import { Location } from '../../models/location';
import { Data } from '../../providers/providers';
import { Thinning } from '../../providers/providers';
import { ThinningDataset } from "../../models/thinning-dataset";


@Component({
  selector: 'page-thinning-measurement-import',
  templateUrl: 'thinning-measurement-import.html'
})
export class ThinningMeasurementImportPage {

  location: Location;
  dataset: ThinningDataset;
  tsvForImport: string;
  importError: string;

  constructor(public navCtrl: NavController,
              public viewCtrl: ViewController,
              navParams: NavParams,
              public data: Data,
              public thinning: Thinning)
  {
    this.location = navParams.get('location');
    this.dataset = navParams.get('dataset');
  }

  parseTsv() {
    const lines = _.split(this.tsvForImport, '\n');
    const header = _.split(lines[0], '\t');
    const measurements = [];

    for (let col = 3; col < header.length; col++) {
      const d = moment(header[col]);
      if (!d.isValid()) {
        this.importError = 'Invalid date in header: ' + header[col];
        return;
      }
      const key = d.format('YYYY-MM-DD');
      measurements.push({
        created: d.format(),
        id: key
      });
    }

    // data rows
    for (let r = 1; r < lines.length; r++) {
      const cols = _.split(lines[r], '\t');
      const key = `${cols[0]}_${cols[1]}_${cols[2]}`;
      for (let col = 3; col < header.length; col++) {
        const meas = measurements[col - 3];
        if (!meas.data) {
          meas.data = {};
        }
        meas.data[key] = +cols[col]; // convert to number!
      }
    }

    // store measurements
    _.each(measurements, (meas) => this.data.addThinningMeasurement(this.dataset, meas) );

    // update measurement summaries...
    // (for some reason this would get triggered multiple times, not sure why - only do it once)
    let updated = false;
    this.data.getThinningMeasurementsCollection(this.dataset).valueChanges().subscribe((ms) => {
      if (!updated) {
        _.each(ms, (measurement) =>
          this.thinning.refreshThinningMeasurementSummary(measurement)
        );
        updated = true;
      }
    });

    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/thinning-measurement-import/thinning-measurement-import.ts